import { connect } from 'react-redux';
import Ratings from '../../../components/event/after-action/ratings';
import {
    updateAfterAction,
    approveAfterAction,
    requestInfoAfterAction,
    updateAndSubmitAfterAction,
    setEventUserAction,
    setEventErrorMessage,
    toggleAARequestModal,
    setFormFieldValidity
} from '../../../actions';

import {
    getEventActions,
    getEventStatus,
    getEventForm
} from '../../../reducers';

const mapStateToProps = state => ({
    eventActions: getEventActions(state),
    status: getEventStatus(state),
    userInfo: state.data.userInfo,
    hasActions: state.events.hasAfterActionActions,
    userIsCreator: state.events.userIsCreator,
    approvers: state.events.aaApprovers,
    tasks: state.events.aaTasks,
    aaStatus: state.events.aaStatus,
    requestModalActive: state.events.aaRequestModalActive,
    userAction: state.events.userAction,
    afterActionUserID: state.event.EventReport.userId,
    groupStatus: state.events.groupStatus,
    eventState: state.event,
    eventForm: getEventForm(state)
});

const mapDispatchToProps = dispatch => ({
    updateAfterAction: data => dispatch(updateAfterAction(data)),
    approveAfterAction: data => dispatch(approveAfterAction(data)),
    requestInfoAfterAction: data => dispatch(requestInfoAfterAction(data)),
    submitAfterAction: data => dispatch(updateAndSubmitAfterAction(data)),
    setEventUserAction: action => dispatch(setEventUserAction(action)),
    setEventErrorMessage: msg => dispatch(setEventErrorMessage(msg)),
    toggleRequestModal: () => dispatch(toggleAARequestModal()),
    setFormFieldValidity: (model, bool) =>
        dispatch(setFormFieldValidity(model, bool))
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Ratings);



// WEBPACK FOOTER //
// ./src/containers/event/after-action/ratings.js